import styled from 'styled-components';

export const CarouselSecondEventDate = styled.div`
  min-height: 22px;
  color: #fff;
`;
